import React, { FunctionComponent } from 'react';
import { v1 as uuid } from 'uuid';
import { useHistory } from 'react-router-dom';
import { BreadCrumbs } from '../../store/modules/application/types';

type BreadCrumbsProps = {
    breadCrumbs?: BreadCrumbs;
};

const BreadCrumb: FunctionComponent<BreadCrumbsProps> = (props) => {
    const { breadCrumbs } = props;
    const history = useHistory();

    const routeChange = (path: string) => {
        history.push(path);
    };
    return (
        <div className="bread-crumbs">
            {breadCrumbs?.map((item) => {
                return (
                    <div key={uuid()} onClick={() => routeChange(item.path)}>
                        {item?.label}&nbsp;
                    </div>
                );
            })}
        </div>
    );
};

export default BreadCrumb;
